'use client';

import React from 'react';

export default function CopyrightNotice({
  className = '',
}: {
  className?: string;
}) {
  const year = new Date().getFullYear();
  return <span className={className}>© Trusti Diagnostics Inc. {year}</span>;
}
